import { useEffect, useState, useCallback } from 'react';
import api from '../services/api';

/**
 * usePackOffers(type)
 *
 * Fetches the currently-active Pack Offers for the given type from
 * /api/pack-offers/list.php. Pricing shown to users always reflects what the
 * admin has configured in `/gestion/packs`.
 *
 * Types : 'booster' | 'quiz_code' | 'category_code'
 */
export default function usePackOffers(type) {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        if (!type) return;
        setLoading(true);
        try {
            const { data } = await api.get('/pack-offers/list.php', { params: { type } });
            setOffers(data.data?.offers || []);
            setError(null);
        } catch (err) {
            setError(err.response?.data?.message || 'Erreur');
            setOffers([]);
        }
        setLoading(false);
    }, [type]);

    useEffect(() => { load(); }, [load]);

    return { offers, loading, error, reload: load };
}
